module.exports = __webpack_public_path__ + "assets/img/aboutUs_bg.c834f2f1.png";